import { jsx as L } from "react/jsx-runtime";
const e = () => /* @__PURE__ */ L(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5 20C20.5 20.5523 20.0523 21 19.5 21L7.5 22C6.94771 22 6.5 21.5523 6.5 21V20.75H3C2.58579 20.75 2.25 20.4142 2.25 20L2.25 4C2.25 3.58579 2.58579 3.25 3 3.25L6.5 3.25V3C6.5 2.44772 6.94771 2 7.5 2L19.5 3C20.0523 3 20.5 3.44772 20.5 4L20.5 20ZM6.5 12.8269L6.5 19.25H3.75L3.75 4.75L6.5 4.75L6.5 11.3269H13.6893L12.0466 9.68414C11.7537 9.39125 11.7537 8.91637 12.0466 8.62348C12.3395 8.33059 12.8143 8.33059 13.1072 8.62348L16.0303 11.5466C16.3232 11.8394 16.3232 12.3143 16.0303 12.6072L13.1072 15.5303C12.8143 15.8232 12.3395 15.8232 12.0466 15.5303C11.7537 15.2374 11.7537 14.7625 12.0466 14.4696L13.6893 12.8269H6.5Z",
    fill: "currentColor"
  }
);
export {
  e as default
};
